var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-wrap d-flex f-column"},[_c(_vm.layout,{directives:[{name:"show",rawName:"v-show",value:(!_vm.lockStatus),expression:"!lockStatus"}],tag:"component"},[_c('router-view')],1),(_vm.lockStatus)?_c('twostep',{attrs:{"show-lock":_vm.lockStatus}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }